export default "__VITE_ASSET__Czod8YRB__"